<template>
  <v-layout row>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-toolbar flat dense card color="transparent">
          <v-toolbar-title>回复列表</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="$emit('close')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-list two-line>
          <template v-for="item in items">
            <!-- <v-subheader v-if="item.header" :key="item.header">{{ item.header }}</v-subheader>
            <v-divider v-else-if="item.divider" :inset="item.inset" :key="index"></v-divider>-->
            <v-list-tile :key="item.CommentReply.Id" avatar>
              <v-list-tile-avatar>
                <img
                  :src="item.ReplayUser.HandIconId?`/api/resource/get/${item.ReplayUser.HandIconId}`:timg"
                >
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>{{item.ReplayUser.Name}}</v-list-tile-title>
                <v-list-tile-sub-title>{{item.CommentReply.ReplyContent}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import timg from "@/assets/timg.jpg";
export default {
  props: {
    Id: String
  },
  data() {
    return {
      items: [],
      timg
    };
  },
  async created() {
    this.items = await this.$http.get(
      `/api/UserComment/CommentReplys/${this.Id}`
    );
  }
};
</script>

<style>
</style>
